import "core-js/modules/es.function.name.js";
import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d47e2dea"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "info-side"
};
var _hoisted_2 = {
  class: "list"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "+配偶", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "+儿女", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "+兄妹", -1);
});

var _hoisted_6 = {
  class: "menuButton"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "+远祖", -1);
});

var _hoisted_8 = {
  class: "menuButton"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "过继", -1);
});

var _hoisted_10 = {
  class: "menuButton"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "标记", -1);
});

var _hoisted_12 = {
  class: "menuButton"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "分房", -1);
});

var _hoisted_14 = {
  class: "menuButton"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "设庄", -1);
});

var _hoisted_16 = {
  class: "menuButton"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "造字", -1);
});

var _hoisted_18 = {
  class: "menuButton"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "统计", -1);
});

var _hoisted_20 = {
  class: "info-r"
};
var _hoisted_21 = {
  class: "info-r-inner"
};

var _hoisted_22 = /*#__PURE__*/_createTextVNode("男");

var _hoisted_23 = /*#__PURE__*/_createTextVNode("女");

var _hoisted_24 = /*#__PURE__*/_createTextVNode("Config");

var _hoisted_25 = /*#__PURE__*/_createTextVNode("Role");

var _hoisted_26 = /*#__PURE__*/_createTextVNode("Task");

import { ref, watch } from 'vue';
export default {
  props: {
    data: {
      // 接收父组件传值,并设置默认值
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['addNewNode'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;

    _useCssVars(function (_ctx) {
      return {
        "2b07799d": boxWidth.value
      };
    });

    var boxWidth = ref('820px');
    var form = ref();
    var rules = ref({
      name: [{
        required: true,
        message: '请输入谱系名称',
        trigger: 'blur'
      }]
    });
    watch(function () {
      form.value = props.data;
    }, {
      deep: true,
      immediate: true
    });

    var toggleRight = function toggleRight() {
      if (boxWidth.value === '820px') {
        boxWidth.value = '0px';
      } else {
        boxWidth.value = '820px';
      }
    };

    var addNewNode = function addNewNode(type) {
      var id = 0;

      switch (type) {
        case 0:
          id = form.value.id;
          break;

        case 1:
          id = form.value.id;
          break;

        case 2:
          id = form.value.parentId;
          break;
      }

      emits('addNewNode', type, id);
    };

    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_radio = _resolveComponent("el-radio");

      var _component_el_radio_group = _resolveComponent("el-radio-group");

      var _component_el_row = _resolveComponent("el-row");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_date_picker = _resolveComponent("el-date-picker");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_svg_icon, {
        icon: boxWidth.value === '820px' ? 'arrow-double-right' : 'arrow-double-left',
        onClick: toggleRight,
        class: "toggle"
      }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "menuButton",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return addNewNode(1);
        })
      }, [_createVNode(_component_svg_icon, {
        icon: "couple",
        class: "svg-container"
      }), _hoisted_3]), _createElementVNode("div", {
        class: "menuButton",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return addNewNode(0);
        })
      }, [_createVNode(_component_svg_icon, {
        icon: "son",
        class: "svg-container"
      }), _hoisted_4]), _createElementVNode("div", {
        class: "menuButton",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return addNewNode(2);
        })
      }, [_createVNode(_component_svg_icon, {
        icon: "brother",
        class: "svg-container"
      }), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_svg_icon, {
        icon: "ancestor",
        class: "svg-container"
      }), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_svg_icon, {
        icon: "relationChange",
        class: "svg-container"
      }), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_svg_icon, {
        icon: "mark",
        class: "svg-container"
      }), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_svg_icon, {
        icon: "house",
        class: "svg-container"
      }), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_svg_icon, {
        icon: "gardon",
        class: "svg-container"
      }), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_svg_icon, {
        icon: "words",
        class: "svg-container"
      }), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_svg_icon, {
        icon: "statistic",
        class: "svg-container"
      }), _hoisted_19])])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_tabs, {
        type: "border-card",
        class: "info-content"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tab_pane, {
            label: "基本信息"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form, {
                ref: "formRef",
                model: form.value,
                "label-width": "120px",
                rules: rules.value
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "姓氏"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.surname,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                                  return form.value.surname = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "名字"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.name,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                                  return form.value.name = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "常用名"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.aliasName,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                                  return form.value.aliasName = $event;
                                }),
                                placeholder: "常用名 (别名)"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "性别",
                            prop: "sex"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_radio_group, {
                                modelValue: form.value.sex,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                                  return form.value.sex = $event;
                                })
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_radio, {
                                    label: 0
                                  }, {
                                    default: _withCtx(function () {
                                      return [_hoisted_22];
                                    }),
                                    _: 1
                                  }), _createVNode(_component_el_radio, {
                                    label: 1
                                  }, {
                                    default: _withCtx(function () {
                                      return [_hoisted_23];
                                    }),
                                    _: 1
                                  })];
                                }),
                                _: 1
                              }, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "头衔"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.title,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                                  return form.value.title = $event;
                                }),
                                placeholder: "请输入"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "字辈"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.symbol,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
                                  return form.value.symbol = $event;
                                }),
                                placeholder: "请输入"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "排行"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                modelValue: form.value.rankingId,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
                                  return form.value.rankingId = $event;
                                })
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '长子' : '长女',
                                    value: 0
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '次子' : '次女',
                                    value: 1
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '三子' : '三女',
                                    value: 2
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '四子' : '四女',
                                    value: 3
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '五子' : '五女',
                                    value: 4
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '六子' : '六女',
                                    value: 5
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '七子' : '七女',
                                    value: 6
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '八子' : '八女',
                                    value: 7
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '九子' : '九女',
                                    value: 8
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '十子' : '十女',
                                    value: 9
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '十一子' : '十一女',
                                    value: 10
                                  }, null, 8, ["label"]), _createVNode(_component_el_option, {
                                    label: form.value.sex === 0 ? '十二子' : '十二女',
                                    value: 11
                                  }, null, 8, ["label"])];
                                }),
                                _: 1
                              }, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "状态"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                modelValue: form.value.statusId,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
                                  return form.value.statusId = $event;
                                })
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_option, {
                                    label: "在世",
                                    value: "0"
                                  }), _createVNode(_component_el_option, {
                                    label: "过世",
                                    value: "1"
                                  })];
                                }),
                                _: 1
                              }, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "父母"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.parentId,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
                                  return form.value.parentId = $event;
                                }),
                                placeholder: "请输入",
                                disabled: form.value.lastItem || form.value.parentType == 1
                              }, null, 8, ["modelValue", "disabled"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "关系"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                modelValue: form.value.relationId,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                                  return form.value.relationId = $event;
                                }),
                                disabled: form.value.lastItem || form.value.parentType == 1
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_option, {
                                    label: "生",
                                    value: "1"
                                  }), _createVNode(_component_el_option, {
                                    label: "嗣",
                                    value: "2"
                                  }), _createVNode(_component_el_option, {
                                    label: "祧",
                                    value: "3"
                                  }), _createVNode(_component_el_option, {
                                    label: "抚",
                                    value: "4"
                                  }), _createVNode(_component_el_option, {
                                    label: "奉祀",
                                    value: "5"
                                  }), _createVNode(_component_el_option, {
                                    label: "无",
                                    value: "6"
                                  })];
                                }),
                                _: 1
                              }, 8, ["modelValue", "disabled"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "配偶"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.parentId,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
                                  return form.value.parentId = $event;
                                }),
                                placeholder: "请输入"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "关系"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                modelValue: form.value.relationId,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
                                  return form.value.relationId = $event;
                                }),
                                disabled: form.value.lastItem || form.value.parentType == 0
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_option, {
                                    label: "娶",
                                    value: "1"
                                  }), _createVNode(_component_el_option, {
                                    label: "继娶",
                                    value: "2"
                                  }), _createVNode(_component_el_option, {
                                    label: "再娶",
                                    value: "3"
                                  }), _createVNode(_component_el_option, {
                                    label: "又娶",
                                    value: "4"
                                  }), _createVNode(_component_el_option, {
                                    label: "妣",
                                    value: "5"
                                  }), _createVNode(_component_el_option, {
                                    label: "继妣",
                                    value: "6"
                                  }), _createVNode(_component_el_option, {
                                    label: "再妣",
                                    value: "7"
                                  }), _createVNode(_component_el_option, {
                                    label: "又妣",
                                    value: "8"
                                  }), _createVNode(_component_el_option, {
                                    label: "妻",
                                    value: "9"
                                  }), _createVNode(_component_el_option, {
                                    label: "适",
                                    value: "10"
                                  }), _createVNode(_component_el_option, {
                                    label: "嫁",
                                    value: "11"
                                  }), _createVNode(_component_el_option, {
                                    label: "正室",
                                    value: "12"
                                  }), _createVNode(_component_el_option, {
                                    label: "配",
                                    value: "13"
                                  }), _createVNode(_component_el_option, {
                                    label: "原配",
                                    value: "14"
                                  }), _createVNode(_component_el_option, {
                                    label: "前妻",
                                    value: "15"
                                  }), _createVNode(_component_el_option, {
                                    label: "继配",
                                    value: "16"
                                  }), _createVNode(_component_el_option, {
                                    label: "宠",
                                    value: "17"
                                  }), _createVNode(_component_el_option, {
                                    label: "妾",
                                    value: "18"
                                  }), _createVNode(_component_el_option, {
                                    label: "续",
                                    value: "19"
                                  }), _createVNode(_component_el_option, {
                                    label: "又",
                                    value: "20"
                                  }), _createVNode(_component_el_option, {
                                    label: "离异",
                                    value: "21"
                                  }), _createVNode(_component_el_option, {
                                    label: "入赘",
                                    value: "22"
                                  }), _createVNode(_component_el_option, {
                                    label: "招婿",
                                    value: "23"
                                  }), _createVNode(_component_el_option, {
                                    label: "霜赘",
                                    value: "24"
                                  }), _createVNode(_component_el_option, {
                                    label: "三娶",
                                    value: "25"
                                  }), _createVNode(_component_el_option, {
                                    label: "四娶",
                                    value: "26"
                                  }), _createVNode(_component_el_option, {
                                    label: "五娶",
                                    value: "27"
                                  }), _createVNode(_component_el_option, {
                                    label: "六娶",
                                    value: "28"
                                  }), _createVNode(_component_el_option, {
                                    label: "三妣",
                                    value: "29"
                                  }), _createVNode(_component_el_option, {
                                    label: "四妣",
                                    value: "30"
                                  }), _createVNode(_component_el_option, {
                                    label: "五妣",
                                    value: "31"
                                  }), _createVNode(_component_el_option, {
                                    label: "六妣",
                                    value: "32"
                                  })];
                                }),
                                _: 1
                              }, 8, ["modelValue", "disabled"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "世数"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.levelName,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
                                  return form.value.levelName = $event;
                                }),
                                placeholder: "请输入",
                                disabled: "true"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "履历"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.education,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
                                  return form.value.education = $event;
                                }),
                                placeholder: "学历"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "noLable"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.company,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
                                  return form.value.company = $event;
                                }),
                                placeholder: "就职单位"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "noLable"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.position,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
                                  return form.value.position = $event;
                                }),
                                placeholder: "职位"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 8
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "出生"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_date_picker, {
                                modelValue: form.value.birthday,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
                                  return form.value.birthday = $event;
                                }),
                                type: "date",
                                placeholder: "Pick a date",
                                style: {
                                  "width": "100%"
                                }
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 4
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "noLable"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                modelValue: form.value.birthdayTime,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
                                  return form.value.birthdayTime = $event;
                                })
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_option, {
                                    label: "子时",
                                    value: "1"
                                  }), _createVNode(_component_el_option, {
                                    label: "丑时",
                                    value: "2"
                                  }), _createVNode(_component_el_option, {
                                    label: "寅时",
                                    value: "3"
                                  }), _createVNode(_component_el_option, {
                                    label: "卯时",
                                    value: "4"
                                  }), _createVNode(_component_el_option, {
                                    label: "辰时",
                                    value: "5"
                                  }), _createVNode(_component_el_option, {
                                    label: "巳时",
                                    value: "6"
                                  }), _createVNode(_component_el_option, {
                                    label: "午时",
                                    value: "7"
                                  }), _createVNode(_component_el_option, {
                                    label: "未时",
                                    value: "8"
                                  }), _createVNode(_component_el_option, {
                                    label: "申时",
                                    value: "9"
                                  }), _createVNode(_component_el_option, {
                                    label: "酉时",
                                    value: "10"
                                  }), _createVNode(_component_el_option, {
                                    label: "戌时",
                                    value: "11"
                                  }), _createVNode(_component_el_option, {
                                    label: "亥时",
                                    value: "12"
                                  })];
                                }),
                                _: 1
                              }, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "现居地"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.address,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
                                  return form.value.address = $event;
                                }),
                                placeholder: "详细地址"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "身份"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.identity,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
                                  return form.value.identity = $event;
                                }),
                                placeholder: "请输入"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 8
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "去世"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_date_picker, {
                                modelValue: form.value.death,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
                                  return form.value.death = $event;
                                }),
                                type: "date",
                                placeholder: "Pick a date",
                                style: {
                                  "width": "100%"
                                }
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 4
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "noLable"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                modelValue: form.value.deathTime,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
                                  return form.value.deathTime = $event;
                                })
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_option, {
                                    label: "子时",
                                    value: "1"
                                  }), _createVNode(_component_el_option, {
                                    label: "丑时",
                                    value: "2"
                                  }), _createVNode(_component_el_option, {
                                    label: "寅时",
                                    value: "3"
                                  }), _createVNode(_component_el_option, {
                                    label: "卯时",
                                    value: "4"
                                  }), _createVNode(_component_el_option, {
                                    label: "辰时",
                                    value: "5"
                                  }), _createVNode(_component_el_option, {
                                    label: "巳时",
                                    value: "6"
                                  }), _createVNode(_component_el_option, {
                                    label: "午时",
                                    value: "7"
                                  }), _createVNode(_component_el_option, {
                                    label: "未时",
                                    value: "8"
                                  }), _createVNode(_component_el_option, {
                                    label: "申时",
                                    value: "9"
                                  }), _createVNode(_component_el_option, {
                                    label: "酉时",
                                    value: "10"
                                  }), _createVNode(_component_el_option, {
                                    label: "戌时",
                                    value: "11"
                                  }), _createVNode(_component_el_option, {
                                    label: "亥时",
                                    value: "12"
                                  })];
                                }),
                                _: 1
                              }, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "葬址"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.burialAddress,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) {
                                  return form.value.burialAddress = $event;
                                }),
                                placeholder: "详细地址"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "享年"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.lifeCycle,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
                                  return form.value.lifeCycle = $event;
                                }),
                                placeholder: "请输入"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "生平"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.introduction,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
                                  return form.value.introduction = $event;
                                }),
                                type: "textarea"
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "后注"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.afterNote,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = function ($event) {
                                  return form.value.afterNote = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          }), _createVNode(_component_el_form_item, {
                            label: "后传"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_input, {
                                modelValue: form.value.afterIntroduction,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
                                  return form.value.afterIntroduction = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_form_item, {
                    label: "立传"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_input, {
                        modelValue: form.value.biography,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) {
                          return form.value.biography = $event;
                        })
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_form_item, {
                    label: "行传"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_input, {
                        modelValue: form.value.content,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = function ($event) {
                          return form.value.content = $event;
                        })
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["model", "rules"])];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "快捷录入",
            class: "info-content"
          }, {
            default: _withCtx(function () {
              return [_hoisted_24];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "帮助说明",
            class: "info-content"
          }, {
            default: _withCtx(function () {
              return [_hoisted_25];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "用户纠错",
            class: "info-content"
          }, {
            default: _withCtx(function () {
              return [_hoisted_26];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])])], 64);
    };
  }
};